export interface ResponseAffectedCompaniesImportingInaccessibleMdrContacts {
  [companyId: string]: AffectedCompanyImportingInaccessibleMdrContacts[];
}

export interface AffectedCompanyImportingInaccessibleMdrContacts {
  id: string;
  name: string;
  partnerName: string;
  mdrContactEmail: string;
}

export const ERROR_CODE_MDR_AFFECTED_COMPANIES = 1;
